import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { GridApi, GridOptions, CellEditingStoppedEvent, ValueFormatterParams } from 'ag-grid-community';
import { FinancialCurrencyEditorComponent } from '../financial-currency-editor/financial-currency-editor.component';
import { FinancialModalComponent } from '../financial-modal/financial-modal.component';
import { RemoveServiceModalComponent } from '../remove-service-modal/remove-service-modal.component';


@Component({
  selector: 'app-financial-grid',
  templateUrl: './financial-grid.component.html',
  styleUrls: ['./financial-grid.component.scss']
})
export class FinancialGridComponent {

  uuid: string | null = '';

  financialInfo: any = {};
  ladingServices: Array<{ [key: string]: string | number | object | boolean }> = [];
  serviceCategories: Array<{ [key: string]: string | number | object | boolean }> = [];
  // Set Financial Info Grid to be hidden until API call is complete
  showFinancialInfo: boolean = false;
  // Default financial grid is non-editable at start
  isFinancialGridEditToggled = false;

  constructor(private http: HttpClient, private route: ActivatedRoute, public dialog: MatDialog, private fb: FormBuilder, private router: Router) { }

  // set up grid API to auto size grids used in the work details page
  private gridApi!: GridApi;

  addRate(){
    let get_rate_url = `/api/rates/get_rates.php`;
    let post_body = {
      "lading_uuid": this.uuid
    };
    this.http.post(get_rate_url, post_body).subscribe(
      (response) => {
        location.reload();
      },
      (error) => {
        console.error(error);
      }
    )
  }

  onGridReady(params: any) {
    this.gridApi = params.api
    this.gridApi = params.api;
    // if (this.showFinancialInfo) {
    //   this.gridApi.sizeColumnsToFit();
    // }
    // Resize columns to fit the grid width
    // this.gridApi?.addEventListener('firstDataRendered', () => {
    // this.autoSizeAll(false);
    // });

  }

  ngOnInit() {

    // get uuid
    this.route.paramMap.subscribe(params => {
      this.uuid = params.get('uuid');
    });

    // retrieve lading services for financial info, if any
    let lading_services_url = `/api/work_orders/lading_service_rates.php?uuid=${this.uuid}`;
    this.http.get<any>(lading_services_url).subscribe(response => {
      this.ladingServices = response;
    })

    // retrieve financial info
    let financials_url = `/api/work_orders/work_order_details_financial.php?uuid=${this.uuid}`;
    this.http.get<any>(financials_url).subscribe(response => {

      this.financialInfo = response;

      this.financialRowData = [
        { lading_service_rate_uuid: null, category: 'Currency', rated_cost: this.financialInfo.cost_currency_type, actual_cost: this.financialInfo.actual_currency_type, billable: this.financialInfo.chargeable_currency_type },
        { lading_service_rate_uuid: null, category: 'Freight Net Cost', rated_cost: this.financialInfo.freight_net_cost, actual_cost: this.financialInfo.freight_net_cost_actual, billable: this.financialInfo.freight_net_billable },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge Rate', rated_cost: this.financialInfo.fuel_surcharge_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_rate_billed },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus Rate', rated_cost: this.financialInfo.fuel_surcharge_plus_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_rate_billed },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge', rated_cost: this.financialInfo.fuel_surcharge_cost, actual_cost: this.financialInfo.fuel_surcharge_cost_actual, billable: this.financialInfo.fuel_surcharge_billed },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus', rated_cost: this.financialInfo.fuel_surcharge_plus_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_billed },
        { lading_service_rate_uuid: null, category: 'Beyond', rated_cost: this.financialInfo.beyond_cost, actual_cost: this.financialInfo.beyond_cost_actual, billable: this.financialInfo.beyond_billed },
        { lading_service_rate_uuid: null, category: 'Discount Rate', rated_cost: '', actual_cost: '', billable: this.financialInfo.discount_rate },
        { lading_service_rate_uuid: null, category: 'Tax Rate', rated_cost: this.financialInfo.tax_rate_multiplier, actual_cost: this.financialInfo.tax_rate_multiplier_actual, billable: this.financialInfo.tax_rate_billed_multiplier },
        { lading_service_rate_uuid: null, category: 'Tax', rated_cost: this.financialInfo.costs_taxes, actual_cost: this.financialInfo.costs_taxes_actual, billable: this.financialInfo.billable_taxes },
        { lading_service_rate_uuid: null, category: 'Gross', rated_cost: this.financialInfo.gross_costs, actual_cost: this.financialInfo.gross_costs_actual, billable: this.financialInfo.gross_billed },
        { lading_service_rate_uuid: null, category: 'Total', rated_cost: this.financialInfo.total_costs, actual_cost: this.financialInfo.total_costs_actual, billable: this.financialInfo.total_charged },
      ]

      // index to insert any lading services to the financial info
      let rowIndex = 7;

      // if lading services exist, add to the financial info data
      this.ladingServices.forEach((rowDataObject) => {
        // Create a new row based on the service
        const newRow = {
          lading_service_rate_uuid: rowDataObject['lading_service_rate_uuid'],
          category: rowDataObject['lading_service_rate'] + " | " + rowDataObject['lading_service_rate_type'],
          rated_cost: rowDataObject['service_cost'],
          actual_cost: rowDataObject['service_cost_actual'],
          billable: rowDataObject['service_billed'],
        };

        // Insert the new service at the 6th index
        this.financialRowData.splice(rowIndex, 0, newRow);
        rowIndex++;
      });

      // Check if all fields are empty for each object in financialRowData
      const isEmpty = this.financialRowData.every(row =>
        row.rated_cost === null || row.rated_cost === undefined || row.rated_cost === '' &&
        row.actual_cost === null || row.actual_cost === undefined || row.actual_cost === '' &&
        row.billable === null || row.billable === undefined || row.billable === ''
      );

      // If all fields are empty, set financialRowData to an empty array
      if (isEmpty) {
        this.financialRowData = [];
      }

      // display the AG-Grid after the API call is completed
      this.showFinancialInfo = true;

      // auto size grid to fit full width of grid horizontally
      // this.gridApi.sizeColumnsToFit();

      // Populate service categories array for remove-service-modal
      this.serviceCategories = this.ladingServices.map(service => ({
        category: `${service['lading_service_rate']} | ${service['lading_service_rate_type']}`,
        uuid: service['lading_service_rate_uuid']
      }));

    })

  }


  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    editable: (params: any) => this.isEditable(params),
    cellClass: 'cell-wrap-text',
    enableCellChangeFlash: true,
  }

  financialRowData: any[] = [];

  enableFinancialEditing() {
    this.isFinancialGridEditToggled = true;
  }

  disableFinancialEditing() {
    this.isFinancialGridEditToggled = false;
  }

  // Function to determine if a cell is editable based on category name for financials
  isEditable(params: any) {
    if (!this.isFinancialGridEditToggled) { // if not toggled on, return false so grid is not editable
      return false;
    } else {
      // Check the category name
      var categoryName = params.data.category;

      // Check column name (for discount rate specifically)
      var columnName = params.colDef.field;

      // List of category names where cells are uneditable
      var uneditableCategories = [
        'Fuel Surcharge',
        'Fuel Surcharge Plus',
        'Tax',
        'Gross',
        'Total'
      ];

      // "Discount Rate" category is only editable under the "Billable" column
      if (categoryName === 'Discount Rate' && columnName !== 'billable') {
        return false;
      }

      // Return true if the category is in the editable list, false otherwise
      return !uneditableCategories.includes(categoryName);
    }
  }

  onToggleChange() {

  }

  financialColumnDefs = [
    { field: 'lading_service_rate_uuid', headerName: 'Lading Service Rate UUID', editable: false, hide: true },
    { field: 'category', headerName: 'Category', editable: false, flex: 7 },
    {
      field: 'rated_cost',
      headerName: 'Rated Cost',
      flex: 1,
      cellEditorSelector: (params: any) => {
        if (params.data.category === 'Currency') {
          return {
            component: FinancialCurrencyEditorComponent,
            params: { value: params.value },
          };
        } else {
          return { component: 'agTextCellEditor' }; // Use default text cell editor
        }
      }
    },
    {
      field: 'actual_cost', headerName: 'Actual Cost', flex: 1,
      cellEditorSelector: (params: any) => {
        if (params.data.category === 'Currency') {
          return {
            component: FinancialCurrencyEditorComponent,
            params: { value: params.value },
          };
        } else {
          return { component: 'agTextCellEditor' }; // Use default text cell editor
        }
      }
    },
    {
      field: 'billable', headerName: 'Billable', flex: 1,
      cellEditorSelector: (params: any) => {
        if (params.data.category === 'Currency') {
          return {
            component: FinancialCurrencyEditorComponent,
            params: { value: params.value },
          };
        } else {
          return { component: 'agTextCellEditor' }; // Use default text cell editor
        }
      }
    }
  ]

  // open modal to add service charge to financial info
  openFinancialModal() {
    const modalRef = this.dialog.open(FinancialModalComponent, {
      data: {
        modalTitle: 'Add New Service Charge',
      },
    });

    // Subscribe to the form submission in the modal
    modalRef.afterClosed().subscribe((formData) => {
      console.log(formData)
      if (formData) {
        console.log('formData:', formData)
        // Add the new row to the financialRowData array
        this.addRowToFinancialData(formData.value);
      }
    });
  }

  openRemoveServiceModal() {
    const modalRef = this.dialog.open(RemoveServiceModalComponent, {

      data: {
        modalTitle: 'Remove Service Charge',
        serviceCategories: this.serviceCategories
      },

    });

    // Subscribe to the form submission in the modal
    modalRef.afterClosed().subscribe((formData) => {
      // URL to retrieve updated lading service rates
      const lading_services_url = `/api/work_orders/lading_service_rates.php?uuid=${this.uuid}`;

      if (formData) {
        const lading_service_rate_uuid = formData.value.selectedService
        const services_url = `/api/work_orders/lading_service_rates.php?lading_service_rate_uuid=${lading_service_rate_uuid}`
        console.log('formData:', formData)
        console.log(formData.value.selectedService)

        return this.http.delete<any>(services_url)
          .subscribe(response => {

            console.log('Delete Response', response)

            this.http.get<any>(lading_services_url).subscribe(response => {
              // update lading services array with service charge removed
              this.ladingServices = response;

              this.calculateRatedFinancials();
              this.calculateBillableFinancials();
              this.calculateActualFinancials();
            })

          })
      }

      return null;
    });
  }

  private addRowToFinancialData(formData: any) {
    // URL to post new service charge
    const services_url = '/api/work_orders/lading_service_rates.php'

    // URL to retrieve updated lading service rates
    const lading_services_url = `/api/work_orders/lading_service_rates.php?uuid=${this.uuid}`;

    // Create a new row object based on the form data
    // const newRow = {
    //   lading_service_rate_uuid: formData.lading_service_rate_uuid,
    //   category: formData.selectedService + ' | ' + formData.selectedServiceType,
    //   rated_cost: formData.rated_cost,
    //   actual_cost: formData.actual_cost,
    //   billable: formData.billable,
    // };

    var postData = {
      lading_uuid: this.uuid,
      lading_service_uuid: this.financialInfo.lading_service_uuid,
      lading_service_rate: formData.selectedService === '' ? null : formData.selectedService,
      lading_service_rate_type: formData.selectedServiceType === '' ? null : formData.selectedServiceType,
      service_cost: formData.rated_cost === '' ? null : formData.rated_cost,
      service_cost_actual: formData.actual_cost === '' ? null : formData.actual_cost,
      service_billed: formData.billable === '' ? null : formData.billable
    }

    return this.http.post<any>(services_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        // update the lading services array with the newly added service charge
        this.http.get<any>(lading_services_url).subscribe(response => {
          this.ladingServices = response;

          // recalculate total rated costs if added service charge contains a rated cost
          if (postData.service_cost !== '') {
            this.calculateRatedFinancials()
          }

          // recalculate total actual costs if added service charge contains an actual cost
          if (postData.service_cost_actual !== '') {
            this.calculateActualFinancials()
          }

          // recalculate total billable costs if added service charge contains a billable cost
          if (postData.service_billed !== '') {
            this.calculateBillableFinancials()
          }
        })
      })
  }

  // allows editing of columns of Financials Grid, updates cells upon exiting out of the cell
  onCellEditingStopped(event: CellEditingStoppedEvent) {

    // grab value being edited, column, and row of node
    var editedValue = event.value;

    console.log('before', editedValue)

    if (!isNaN(parseFloat(editedValue)) && isFinite(editedValue) || editedValue == null || editedValue == 'USD' || editedValue == 'CAD') {
      const rowNode = event.node;
      const column = event.column;

      console.log('et', editedValue)

      // grab category and column name of node
      const columnName = column.getColId();
      const categoryName = rowNode.data.category

      // const themeElement = document.querySelector('--ag-value-change-value-highlight-background-color');

      // this.gridApi.flashCells({
      //   rowNodes: [rowNode],
      //   columns: [columnName],
      //   flashDuration: 3000,
      //   fadeDuration: 2000
      // })

      // grab UUIDs to send to API call
      const lading_service_uuid = this.financialInfo.lading_service_uuid;
      const service_rate_uuid = rowNode.data.lading_service_rate_uuid;

      // create URLs to send POST data to
      const financial_url = '/api/work_orders/work_order_details_financial.php'
      const services_url = '/api/work_orders/lading_service_rates.php'

      // if empty cell, set value to null
      if (editedValue == "") {
        editedValue = null;
      }

      var postData = {}

      // if an edit is made on the financials info which is NOT an added service charge
      if (service_rate_uuid == null) {
        switch (columnName) {
          case 'rated_cost':
            switch (categoryName) {
              case 'Currency':
                this.financialInfo.cost_currency_type = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "cost_currency_type": editedValue,
                }
                break;
              case 'Freight Net Cost':
                this.financialInfo.freight_net_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "freight_net_cost": editedValue,
                }
                break;
              case 'Fuel Surcharge Rate':
                this.financialInfo.fuel_surcharge_rate_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_rate_cost": editedValue,
                }
                console.log(postData)
                break;
              case 'Fuel Surcharge Plus Rate':
                this.financialInfo.fuel_surcharge_plus_rate_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_plus_rate_cost": editedValue,
                }
                break;
              case 'Beyond':
                this.financialInfo.beyond_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "beyond_cost": editedValue,
                }
                break;
              case 'Tax Rate':
                this.financialInfo.tax_rate_multiplier = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "tax_rate_multiplier": editedValue,
                }
                break;
            }
            break;
          case 'actual_cost':
            console.log('this is actual cost');
            switch (categoryName) {
              case 'Currency':
                this.financialInfo.actual_currency_type = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "actual_currency_type": editedValue,
                }
                break;
              case 'Freight Net Cost':
                this.financialInfo.freight_net_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "freight_net_cost_actual": editedValue,
                }
                break;
              case 'Fuel Surcharge Rate':
                this.financialInfo.fuel_surcharge_rate_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_rate_cost_actual": editedValue,
                }
                break;
              case 'Fuel Surcharge Plus Rate':
                this.financialInfo.fuel_surcharge_plus_rate_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_plus_rate_cost_actual": editedValue,
                }
                break;
              case 'Beyond':
                this.financialInfo.beyond_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "beyond_cost_actual": editedValue,
                }
                break;
              case 'Tax Rate':
                this.financialInfo.tax_rate_multiplier_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "tax_rate_multiplier_actual": editedValue,
                }
                break;
            }
            break;
          case 'billable':
            console.log('this is billable')
            switch (categoryName) {
              case 'Currency':
                this.financialInfo.chargeable_currency_type = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "chargeable_currency_type": editedValue,
                }
                break;
              case 'Freight Net Cost':
                this.financialInfo.freight_net_billable = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "freight_net_billable": editedValue,
                }
                break;
              case 'Fuel Surcharge Rate':
                this.financialInfo.fuel_surcharge_rate_billed = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_rate_billed": editedValue,
                }
                break;
              case 'Fuel Surcharge Plus Rate':
                this.financialInfo.fuel_surcharge_plus_rate_billed = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_plus_rate_billed": editedValue,
                }
                break;
              case 'Beyond':
                this.financialInfo.beyond_billed = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "beyond_billed": editedValue,
                }
                break;
              case 'Discount Rate':
                this.financialInfo.discount_rate = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "discount_rate": editedValue,
                }
                break;
              case 'Tax Rate':
                this.financialInfo.tax_rate_billed_multiplier = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "tax_rate_billed_multiplier": editedValue,
                }
                break;
            }
            break;
          default:
            console.log('Unnamed Column');
        }

        return this.http.post<any>(financial_url, postData)
          .subscribe(response => {
            console.log('Post Response: ', response)
            if (columnName == 'rated_cost') {
              this.calculateRatedFinancials()
            } else if (columnName == 'billable') {
              this.calculateBillableFinancials()
            } else if (columnName == 'actual_cost') {
              this.calculateActualFinancials()
            }
          })

        // if an edit is made on an added service charge
      } else {

        // Find the corresponding service in ladingServices array
        const editedServiceIndex = this.ladingServices.findIndex(service => service['lading_service_rate_uuid'] === service_rate_uuid);

        // ensure service exists before making changes
        if (editedServiceIndex !== -1) {
          switch (columnName) {
            case 'rated_cost':
              this.ladingServices[editedServiceIndex]['service_cost'] = editedValue
              postData = {
                lading_service_rate_uuid: service_rate_uuid,
                "service_cost": editedValue,
              }
              break;
            case 'actual_cost':
              this.ladingServices[editedServiceIndex]['service_cost_actual'] = editedValue
              postData = {
                lading_service_rate_uuid: service_rate_uuid,
                "service_cost_actual": editedValue,
              }
              break;
            case 'billable':
              this.ladingServices[editedServiceIndex]['service_billed'] = editedValue
              postData = {
                lading_service_rate_uuid: service_rate_uuid,
                "service_billed": editedValue,
              }
              break;
          }
        }

        return this.http.post<any>(services_url, postData)
          .subscribe(response => {
            console.log('Post Response: ', response)
            if (columnName == 'rated_cost') {
              this.calculateRatedFinancials()
            } else if (columnName == 'billable') {
              this.calculateBillableFinancials()
            } else if (columnName == 'actual_cost') {
              this.calculateActualFinancials()
            }
          })
      }

    } else {
      this.updateFinancialRows();
      return null;
    }

  }

  // Calculations for the Rated Cost column in Financials Grid
  calculateRatedFinancials() {
    var subtotal = 0;
    var total = 0;
    const freight_cost = parseFloat(this.financialInfo.freight_net_cost)
    const beyond_cost = parseFloat(this.financialInfo.beyond_cost)
    var fuel_surcharge = parseFloat(this.financialInfo.fuel_surcharge_rate_cost)
    var fuel_surcharge_plus = parseFloat(this.financialInfo.fuel_surcharge_plus_rate_cost)
    var tax = parseFloat(this.financialInfo.tax_rate_multiplier)

    // Add freight_cost to subtotal if it's not null
    if (!isNaN(freight_cost) && freight_cost !== null) {
      subtotal += freight_cost;
    }

    // Add beyond_cost to subtotal if it's not null
    if (!isNaN(beyond_cost) && beyond_cost !== null) {
      subtotal += beyond_cost;
    }

    // loop through each lading service (if any)
    this.ladingServices.forEach(service => {
      if (service['service_cost'] !== null) {
        const cost = service['service_cost']
        const costValue = parseFloat(cost.toString());

        if (!isNaN(costValue)) {
          subtotal += costValue;
        }

      }
    })

    // update gross cost
    this.financialInfo.gross_costs = subtotal.toFixed(2)

    // if fuel_surcharge rate is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge) && fuel_surcharge > 0) {
      var fuel_surcharge_cost = freight_cost * fuel_surcharge
      this.financialInfo.fuel_surcharge_cost = fuel_surcharge_cost.toFixed(2)
      subtotal = subtotal + fuel_surcharge_cost
      this.financialInfo.gross_costs = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_cost = ''
    }

    // if fuel_surcharge rate plus is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge_plus) && fuel_surcharge_plus > 0) {
      var fuel_surcharge_plus_cost = freight_cost * fuel_surcharge_plus
      this.financialInfo.fuel_surcharge_plus_cost = fuel_surcharge_plus_cost.toFixed(2)
      subtotal = subtotal + fuel_surcharge_plus_cost
      this.financialInfo.gross_costs = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_plus_cost = ''
    }

    // apply taxes if applicable
    if (!isNaN(tax) && tax > 0) {
      var tax_cost = subtotal * tax;
      total = subtotal + tax_cost
      this.financialInfo.costs_taxes = tax_cost.toFixed(2)
      this.financialInfo.total_costs = total.toFixed(2)
    } else {
      // if tax rate is deleted, remove tax cost
      this.financialInfo.costs_taxes = ''
      total = subtotal
      this.financialInfo.total_costs = total.toFixed(2)
    }

    // update the financial row data with the updated calculations
    this.updateFinancialRows()

    // after updating, update database with final calculations
    const financial_url = '/api/work_orders/work_order_details_financial.php'
    const lading_service_uuid = this.financialInfo.lading_service_uuid;

    // Function to replace empty strings with null
    function replaceEmptyWithNull(value: string) {
      return value === '' ? null : value;
    }

    var postData = {
      lading_service_uuid: lading_service_uuid,
      // there is no field within the lading services table for fuel_surcharge_costs:
      // "fuel_surcharge_cost": this.financialInfo.fuel_surcharge_cost,
      // "fuel_surcharge_plus_cost": this.financialInfo.fuel_surcharge_plus_cost,
      "costs_taxes": replaceEmptyWithNull(this.financialInfo.costs_taxes),
      "gross_costs": replaceEmptyWithNull(this.financialInfo.gross_costs),
      "total_costs": replaceEmptyWithNull(this.financialInfo.total_costs)
    }

    return this.http.post<any>(financial_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
  }

  // Calculations for the Actual Cost column in Financials Grid
  calculateActualFinancials() {
    var subtotal = 0;
    var total = 0;
    const freight_cost = parseFloat(this.financialInfo.freight_net_cost_actual)
    const beyond_cost = parseFloat(this.financialInfo.beyond_cost_actual)
    var fuel_surcharge = parseFloat(this.financialInfo.fuel_surcharge_rate_cost_actual)
    var fuel_surcharge_plus = parseFloat(this.financialInfo.fuel_surcharge_plus_rate_cost_actual)
    var tax = parseFloat(this.financialInfo.tax_rate_multiplier_actual)

    // Add freight_cost to subtotal if it's not null
    if (!isNaN(freight_cost) && freight_cost !== null) {
      subtotal += freight_cost;
    }

    // Add beyond_cost to subtotal if it's not null
    if (!isNaN(beyond_cost) && beyond_cost !== null) {
      subtotal += beyond_cost;
    }

    // loop through each lading service (if any)
    this.ladingServices.forEach(service => {
      if (service['service_cost_actual'] !== null) {
        const cost = service['service_cost_actual']
        const costValue = parseFloat(cost.toString());

        if (!isNaN(costValue)) {
          subtotal += costValue;
        }

      }
    })

    // update gross cost
    this.financialInfo.gross_costs_actual = subtotal.toFixed(2)

    // if fuel_surcharge rate is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge) && fuel_surcharge > 0) {
      var fuel_surcharge_cost_actual = freight_cost * fuel_surcharge
      this.financialInfo.fuel_surcharge_cost_actual = fuel_surcharge_cost_actual.toFixed(2)
      subtotal = subtotal + fuel_surcharge_cost_actual
      this.financialInfo.gross_costs_actual = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_cost_actual = ''
    }

    // if fuel_surcharge rate plus is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge_plus) && fuel_surcharge_plus > 0) {
      var fuel_surcharge_plus_cost_actual = freight_cost * fuel_surcharge_plus
      this.financialInfo.fuel_surcharge_plus_cost_actual = fuel_surcharge_plus_cost_actual.toFixed(2)
      subtotal = subtotal + fuel_surcharge_plus_cost_actual
      this.financialInfo.gross_costs_actual = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_plus_cost_actual = ''
    }

    // apply taxes if applicable
    if (!isNaN(tax) && tax > 0) {
      var tax_cost = subtotal * tax;
      total = subtotal + tax_cost
      this.financialInfo.costs_taxes_actual = tax_cost.toFixed(2)
      this.financialInfo.total_costs_actual = total.toFixed(2)
    } else {
      // if tax rate is deleted, remove tax cost
      this.financialInfo.costs_taxes_actual = ''
      total = subtotal
      this.financialInfo.total_costs_actual = total.toFixed(2)
    }

    // update the financial row data with the updated calculations
    this.updateFinancialRows()

    // after updating, update database with final calculations
    const financial_url = '/api/work_orders/work_order_details_financial.php'
    const lading_service_uuid = this.financialInfo.lading_service_uuid;

    // Function to replace empty strings with null
    function replaceEmptyWithNull(value: string) {
      return value === '' ? null : value;
    }

    var postData = {
      lading_service_uuid: lading_service_uuid,
      // there is no field within the lading services table for fuel_surcharge_costs:
      // "fuel_surcharge_cost": this.financialInfo.fuel_surcharge_cost,
      // "fuel_surcharge_plus_cost": this.financialInfo.fuel_surcharge_plus_cost,
      "costs_taxes_actual": replaceEmptyWithNull(this.financialInfo.costs_taxes_actual),
      "gross_costs_actual": replaceEmptyWithNull(this.financialInfo.gross_costs_actual),
      "total_costs_actual": replaceEmptyWithNull(this.financialInfo.total_costs_actual)
    }

    return this.http.post<any>(financial_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
  }

  // Calculations for the Billable column in Financials Grid
  calculateBillableFinancials() {
    var subtotal = 0;
    var total = 0;
    const freight_cost = parseFloat(this.financialInfo.freight_net_billable)
    const beyond_cost = parseFloat(this.financialInfo.beyond_billed)
    const discount = parseFloat(this.financialInfo.discount_rate)
    var fuel_surcharge = parseFloat(this.financialInfo.fuel_surcharge_rate_billed)
    var fuel_surcharge_plus = parseFloat(this.financialInfo.fuel_surcharge_plus_rate_billed)
    var tax = parseFloat(this.financialInfo.tax_rate_billed_multiplier)

    // Add freight_cost to subtotal if it's not null
    if (!isNaN(freight_cost) && freight_cost !== null) {
      subtotal += freight_cost;
    }

    // Add beyond_cost to subtotal if it's not null
    if (!isNaN(beyond_cost) && beyond_cost !== null) {
      subtotal += beyond_cost;
    }

    // loop through each lading service (if any)
    this.ladingServices.forEach(service => {
      if (service['service_billed'] !== null) {
        const cost = service['service_billed']
        const costValue = parseFloat(cost.toString());

        if (!isNaN(costValue)) {
          subtotal += costValue;
        }

      }
    })

    // update gross cost
    this.financialInfo.gross_billed = subtotal.toFixed(2)

    // if fuel_surcharge rate is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge) && fuel_surcharge > 0) {
      var fuel_surcharge_billed = freight_cost * fuel_surcharge
      this.financialInfo.fuel_surcharge_billed = fuel_surcharge_billed.toFixed(2)
      subtotal = subtotal + fuel_surcharge_billed
      this.financialInfo.gross_billed = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_billed = ''
    }

    // if fuel_surcharge rate plus is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge_plus) && fuel_surcharge_plus > 0) {
      var fuel_surcharge_plus_billed = freight_cost * fuel_surcharge_plus
      this.financialInfo.fuel_surcharge_plus_billed = fuel_surcharge_plus_billed.toFixed(2)
      subtotal = subtotal + fuel_surcharge_plus_billed
      this.financialInfo.gross_billed = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_plus_billed = ''
    }

    // if discount is applicable
    if (!isNaN(discount) && discount > 0) {
      subtotal = subtotal - (subtotal * discount)
    }

    // apply taxes if applicable
    if (!isNaN(tax) && tax > 0) {
      var tax_cost = subtotal * tax;
      total = subtotal + tax_cost
      this.financialInfo.billable_taxes = tax_cost.toFixed(2)
      this.financialInfo.total_charged = total.toFixed(2)
    } else {
      // if tax rate is deleted, remove tax cost
      this.financialInfo.billable_taxes = ''
      total = subtotal
      this.financialInfo.total_charged = total.toFixed(2)
    }

    // update the financial row data with the updated calculations
    this.updateFinancialRows()

    // after updating, update database with final calculations
    const financial_url = '/api/work_orders/work_order_details_financial.php'
    const lading_service_uuid = this.financialInfo.lading_service_uuid;

    // Function to replace empty strings with null
    function replaceEmptyWithNull(value: string) {
      return value === '' ? null : value;
    }

    var postData = {
      lading_service_uuid: lading_service_uuid,
      // there is no field within the lading services table for fuel_surcharge_costs:
      // "fuel_surcharge_cost": this.financialInfo.fuel_surcharge_cost,
      // "fuel_surcharge_plus_cost": this.financialInfo.fuel_surcharge_plus_cost,
      "billable_taxes": replaceEmptyWithNull(this.financialInfo.billable_taxes),
      "gross_billed": replaceEmptyWithNull(this.financialInfo.gross_billed),
      "total_charged": replaceEmptyWithNull(this.financialInfo.total_charged)
    }

    return this.http.post<any>(financial_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
  }

  updateFinancialRows() {

    this.financialRowData = [
      { lading_service_rate_uuid: null, category: 'Currency', rated_cost: this.financialInfo.cost_currency_type, actual_cost: this.financialInfo.actual_currency_type, billable: this.financialInfo.chargeable_currency_type },
      { lading_service_rate_uuid: null, category: 'Freight Net Cost', rated_cost: this.financialInfo.freight_net_cost, actual_cost: this.financialInfo.freight_net_cost_actual, billable: this.financialInfo.freight_net_billable },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge Rate', rated_cost: this.financialInfo.fuel_surcharge_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_rate_billed },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus Rate', rated_cost: this.financialInfo.fuel_surcharge_plus_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_rate_billed },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge', rated_cost: this.financialInfo.fuel_surcharge_cost, actual_cost: this.financialInfo.fuel_surcharge_cost_actual, billable: this.financialInfo.fuel_surcharge_billed },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus', rated_cost: this.financialInfo.fuel_surcharge_plus_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_billed },
      { lading_service_rate_uuid: null, category: 'Beyond', rated_cost: this.financialInfo.beyond_cost, actual_cost: this.financialInfo.beyond_cost_actual, billable: this.financialInfo.beyond_billed },
      { lading_service_rate_uuid: null, category: 'Discount Rate', rated_cost: '', actual_cost: '', billable: this.financialInfo.discount_rate },
      { lading_service_rate_uuid: null, category: 'Tax Rate', rated_cost: this.financialInfo.tax_rate_multiplier, actual_cost: this.financialInfo.tax_rate_multiplier_actual, billable: this.financialInfo.tax_rate_billed_multiplier },
      { lading_service_rate_uuid: null, category: 'Tax', rated_cost: this.financialInfo.costs_taxes, actual_cost: this.financialInfo.costs_taxes_actual, billable: this.financialInfo.billable_taxes },
      { lading_service_rate_uuid: null, category: 'Gross', rated_cost: this.financialInfo.gross_costs, actual_cost: this.financialInfo.gross_costs_actual, billable: this.financialInfo.gross_billed },
      { lading_service_rate_uuid: null, category: 'Total', rated_cost: this.financialInfo.total_costs, actual_cost: this.financialInfo.total_costs_actual, billable: this.financialInfo.total_charged },
    ]

    // index to insert any lading services to the financial info
    let rowIndex = 7;

    // if lading services exist, add to the financial info data
    this.ladingServices.forEach((rowDataObject) => {
      // Create a new row based on the service
      const newRow = {
        lading_service_rate_uuid: rowDataObject['lading_service_rate_uuid'],
        category: rowDataObject['lading_service_rate'] + " | " + rowDataObject['lading_service_rate_type'],
        rated_cost: rowDataObject['service_cost'],
        actual_cost: rowDataObject['service_cost_actual'],
        billable: rowDataObject['service_billed'],
      };

      // Insert the new service at the 6th index
      this.financialRowData.splice(rowIndex, 0, newRow);
      rowIndex++;
    });

    // Populate service categories array for remove-service-modal
    this.serviceCategories = this.ladingServices.map(service => ({
      category: `${service['lading_service_rate']} | ${service['lading_service_rate_type']}`,
      uuid: service['lading_service_rate_uuid']
    }));

  }

}
